export const addUtils = (
  {
    center,
    gray,
    bright,
    secondary,
    primary,
    dark,
    bgDarkMid,
    bgDark,
    bgPrimaryDark,
    bgGradUp,
    bgGradDown,
    bgPrimary,
    my0,
    myXs,
    mySm,
    myMd,
    myLg,
    myXl,
    mx0,
    mxXs,
    mxSm,
    mxMd,
    mxLg,
    mxXl,
    px0,
    py0,
    pyXs,
    pySm,
    pyMd,
    pyLg,
    pyXl,
    pxXs,
    pxSm,
    pxMd,
    pbXs,
    border,
    borderY,
    borderT,
    borderB,
    uppercase,
    ttNone,
    w100,
    w50,
    wmdf300, // md breakpoint, fixed width 300px,
    h100,
    dFlex,
    dInlineBlock,
    tAlignL,
    vAlignM,
    noWrap,
    ...restProps
  },
) => {
  const utilClassNames = {
    'ss_pos--center': center,
    'ss_color--bright': bright,
    'ss_color--gray': gray,
    'ss_color--secondary': secondary,
    'ss_color--primary': primary,
    'ss_color--dark': dark,
    'ss_bg--dark': bgDark,
    'ss_bg--dark-mid': bgDarkMid,
    'ss_bg--primary-dark': bgPrimaryDark,
    'ss_bg--grad-up': bgGradUp,
    'ss_bg--grad-down': bgGradDown,
    'ss_bg--primary': bgPrimary,
    'ss_my--0': my0,
    'ss_my--xs': myXs,
    'ss_my--sm': mySm,
    'ss_my--md': myMd,
    'ss_my--lg': myLg,
    'ss_my--xl': myXl,
    'ss_mx--0': mx0,
    'ss_mx--xs': mxXs,
    'ss_mx--sm': mxSm,
    'ss_mx--md': mxMd,
    'ss_mx--lg': mxLg,
    'ss_px--0': px0,
    'ss_py--0': py0,
    'ss_py--xs': pyXs,
    'ss_py--sm': pySm,
    'ss_py--md': pyMd,
    'ss_py--lg': pyLg,
    'ss_py--xl': pyXl,
    'ss_px--xs': pxXs,
    'ss_px--sm': pxSm,
    'ss_px--md': pxMd,
    'ss_pb--xs': pbXs,
    ss_border: border,
    'ss_border--y': borderY,
    'ss_border--t': borderT,
    'ss_border--b': borderB,
    'ss_tt--uppercase': uppercase,
    'ss_tt--none': ttNone,
    'ss_d--flex': dFlex,
    'ss_d--inline-block': dInlineBlock,
    'ss_w--100': w100,
    'ss_w--50': w50,
    'ss_w--mdf300': wmdf300,
    'ss_h--100': h100,
    'ss_text-align--left': tAlignL,
    'ss_vertical-align--middle': vAlignM,
    'ss_no-wrap': noWrap,
  };

  return {
    utilClassNames,
    restProps,
  };
};

export const applyDefaultClass = (variants, defaultClassName) => (
  !Object.values(variants).includes(true) && defaultClassName
);
